<template>
    <router-link class="ref-link" :to="{ name: pageName, params: pageParams }" target="_blank">
        {{ linkText }}
    </router-link>
</template>

<script>
export default {
    name: 'LinkRenderer',
    data() {
        return {
            pageParams: null,
            linkText: null,
            pageName: null
        };
    },
    beforeMount() {
        this.updateDisplay(this.params);
    },
    methods: {
        refresh(params) {
            this.updateDisplay(params);
        },
        updateDisplay(params) {
            this.pageName = params.pageName;
            this.pageParams = params.pageParams;
            this.linkText = params.linkText;
        }
    }
};
</script>

<style lang="scss" scoped>
.ref-link {
    color: rgba(0, 0, 0, 0.87) !important;
}

.ref-link:hover {
    color: #2b93ff !important;
}
</style>
